module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "user-client",
    staticStyle: {
      "height": "calc(100% - 60px)"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "border-bottom": "1px solid #CCC",
      "margin-left": "0px",
      "margin-right": "0px",
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "col-xs-8",
    staticStyle: {
      "border-right": "0px solid #CCC"
    }
  }, [_c('h2', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('i', {
    staticClass: "fa fa-user",
    class: _vm.typeIconClass,
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n        Agent: \n        "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.sexText)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.userCallCenter.firstName)
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.userCallCenter.lastName)
    }
  }), _vm._v(" - \n        "), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link",
    attrs: {
      "type": "button",
      "title": "von ccpronto abmelden"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('logout')
      }
    }
  }, [_c('span', {
    staticStyle: {
      "padding-right": "5px"
    }
  }, [_vm._v("Logout")]), _vm._v(" "), _c('span', {}, [_vm._v("(" + _vm._s(_vm.aclText) + ")")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 "
  }, [(!_vm.acdLogedIn) ? _c('div', {
    staticClass: "text-right"
  }, [(!_vm.acdKey) ? _c('span', {
    staticStyle: {
      "color": "#777",
      "font-size": "1.3em"
    },
    domProps: {
      "textContent": _vm._s('Kein AcdKey/Platz vorhanden')
    }
  }) : _c('div', [_c('span', {
    staticStyle: {
      "color": "#777",
      "font-size": "1.3em"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://acd1.in-acd.de/acdweb/index.jsf",
      "target": "_blank"
    }
  }, [_vm._v("ACD:")]), _vm._v(" " + _vm._s(_vm.acdKey) + " ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onAcdLogin
    }
  }, [_vm._v("\n              Anmelden\n              "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "fa fa-sign-in",
    attrs: {
      "title": "ACD Login",
      "aria-hidden": "true"
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.acdLogedIn) ? _c('div', {
    staticClass: "text-right"
  }, [_c('span', {
    staticStyle: {
      "color": "#777",
      "font-size": "1.3em"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://acd1.in-acd.de/acdweb/index.jsf",
      "target": "_blank"
    }
  }, [_vm._v("ACD:")]), _vm._v(" " + _vm._s(_vm.acdKey) + " ")]), _vm._v(" "), (!_vm.acdPlay) ? _c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "button",
      "title": "ACD starten"
    },
    on: {
      "click": _vm.onAcdPauseEnd
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (1),
      expression: "1"
    }],
    staticClass: "fa fa-play ",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.acdPlay) ? _c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "button",
      "title": "ACD pause"
    },
    on: {
      "click": _vm.onAcdPauseStart
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (1),
      expression: "1"
    }],
    staticClass: "fa fa-pause ",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onAcdLogout
    }
  }, [_vm._v("\n            Abmelden \n            "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "fa fa-sign-out",
    attrs: {
      "title": "ACD Logout",
      "aria-hidden": "true"
    }
  })])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "calc(100% - 45px)"
    }
  }, [_c('div', {
    staticClass: "col-xs-8",
    staticStyle: {
      "border-right": "0px solid #CCC",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "cc-memo-list"
  }, [_c('div', {
    staticClass: "panel-group",
    attrs: {
      "id": "user-client-memo-accordion",
      "role": "tablist",
      "aria-multiselectable": "true"
    }
  }, _vm._l((_vm.memos), function(memo, index) {
    return _c('cc-memo', {
      key: memo.id,
      staticClass: "cc-memo-item",
      attrs: {
        "collapseIn": (false),
        "data_parent": 'user-client-memo-accordion',
        "memo": memo
      },
      on: {
        "remove": _vm.onRemoveMemo,
        "update": _vm.onSetMemo
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.memos.length),
      expression: "!memos.length"
    }],
    staticClass: "alert alert-warning",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("Keine internen Vorgaben")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2fa79ba1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/UserCallCenter.vue
// module id = 267
// module chunks = 0